var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.consignment)?_c('div',[_c('ShipmentBase',{model:{value:(_vm.consignment),callback:function ($$v) {_vm.consignment=$$v},expression:"consignment"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }